// eslint-disable-next-line no-shadow
enum MainActionTypesEnum {
  SET_MENSAGEM_SUCESSO = 'SET_MENSAGEM_SUCESSO',
  SET_AUTHENTICATED = 'SET_AUTHENTICATED',
  LOGOUT_HANDLER = 'LOGOUT_HANDLER',
}

export default MainActionTypesEnum;
